import { User } from "lucide-react";

interface UserQuestionBubbleProps {
  question: string;
  isFollowup?: boolean;
}

const UserQuestionBubble = ({ question, isFollowup = false }: UserQuestionBubbleProps) => {
  return (
    <div className="mb-8 max-md:mb-6 max-sm:mb-4 w-full max-w-full" dir="rtl">
      {/* Question Bubble */}
      <div className="relative w-full">
        <div className="bg-gradient-to-r from-indigo-100 to-purple-100 rounded-2xl shadow-lg border border-indigo-200 w-full p-6 max-md:p-5 max-sm:p-4">
          <div className="flex items-start gap-4 w-full flex-row">
            <div className="flex-shrink-0">
              <div className="bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center shadow-md w-10 h-10 max-md:w-8 max-md:h-8">
                <User className="text-white w-5 h-5 max-md:w-4 max-md:h-4" />
              </div>
            </div>
            <div className="flex-1 min-w-0 w-full overflow-hidden">
              {isFollowup && "שאלת המשך"}
              {/* Question text with proper word breaking and overflow handling */}
              <h1
                className="text-indigo-900 text-right leading-relaxed font-medium text-lg max-md:text-base max-sm:text-sm break-words overflow-wrap-anywhere hyphens-auto w-full"
                style={{ 
                  wordBreak: "break-word", 
                  overflowWrap: "break-word",
                  hyphens: "auto"
                }}
              >
                {question}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserQuestionBubble;
